// extracted by mini-css-extract-plugin
module.exports = {"password-reset-form__code-section":"GetCode_password-reset-form__code-section__25clA","password-reset-form":"GetCode_password-reset-form__3Y9_2"};